<template>
	<div v-if="!dataSame">
		<old-version-marker/>
		<costs-table
			:actions-data="oldActions"
			:administrative-costs="oldAdministrativeCosts"
			:offer-configuration="configuration"
			:readonly="true"
		/>
		<new-version-marker/>
		<costs-table
			:actions-data="currentActions"
			:administrative-costs="currentAdministrativeCosts"
			:offer-configuration="configuration"
			:readonly="true"
		/>
		<br>
		<br>
	</div>
</template>

<script>
	import OldVersionMarker from "./oldVersionMarker";
	import NewVersionMarker from "./NewVersionMarker";
	import CostsTable from "../components/CostsTableComponents/CostsTable";

	export default {
		name: "CompareCostsTable",

		components: {CostsTable, NewVersionMarker, OldVersionMarker},

		computed: {
			dataSame () {
        let idKeyReplacer = (key, value) => {
          if (key === 'id') {
            return undefined;
          }
          return value;
        };

        let oldActionsCopy = JSON.parse(JSON.stringify(this.oldActions, idKeyReplacer));
        let actionsCopy = JSON.parse(JSON.stringify(this.currentActions, idKeyReplacer));

				let comparisonResult = JSON.stringify(oldActionsCopy) === JSON.stringify(actionsCopy) &&
					JSON.stringify(this.oldAdministrativeCosts) === JSON.stringify(this.currentAdministrativeCosts);

				if (comparisonResult === false) {
					this.$emit('dataDiffer', true);
				}
				return comparisonResult;
			}
		},

		props: {
			configuration: {},

			oldAdministrativeCosts: {},
			oldActions: {},

			currentAdministrativeCosts: {},
			currentActions: {},
		}
	};
</script>

<style scoped>

</style>
